var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 23C1.8125 23 1.22417 22.7857 0.735 22.3571C0.245833 21.9285 0.000833333 21.4126 0 20.8095V9.85714C0 9.25476 0.245 8.73927 0.735 8.31067C1.225 7.88206 1.81333 7.6674 2.5 7.66667H3.75V5.47619C3.75 3.96111 4.35958 2.66983 5.57875 1.60233C6.79792 0.534842 8.27167 0.000730906 10 7.47603e-07C11.7283 -0.000729411 13.2025 0.533382 14.4225 1.60233C15.6425 2.67129 16.2517 3.96257 16.25 5.47619V7.66667H17.5C18.1875 7.66667 18.7762 7.88133 19.2662 8.31067C19.7562 8.74 20.0008 9.25549 20 9.85714V20.8095C20 21.4119 19.7554 21.9278 19.2662 22.3571C18.7771 22.7864 18.1883 23.0007 17.5 23H2.5ZM10 17.5238C10.6875 17.5238 11.2762 17.3095 11.7662 16.8809C12.2562 16.4523 12.5008 15.9364 12.5 15.3333C12.4992 14.7302 12.2546 14.2147 11.7662 13.7869C11.2779 13.359 10.6892 13.1443 10 13.1429C9.31083 13.1414 8.7225 13.3561 8.235 13.7869C7.7475 14.2177 7.5025 14.7331 7.5 15.3333C7.4975 15.9335 7.7425 16.4494 8.235 16.8809C8.7275 17.3124 9.31583 17.5267 10 17.5238ZM6.25 7.66667H13.75V5.47619C13.75 4.56349 13.3854 3.7877 12.6562 3.14881C11.9271 2.50992 11.0417 2.19048 10 2.19048C8.95833 2.19048 8.07292 2.50992 7.34375 3.14881C6.61458 3.7877 6.25 4.56349 6.25 5.47619V7.66667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.a84a2c644eb1fdf29616a8416120f4f8.svg";
export { ForwardRef as ReactComponent };